import { HiPause, HiPlay } from 'react-icons/hi'
import { useEffect, useRef, useState } from 'react'
import { Progress } from '@/components/ui/index'

export default function MiniAudioPlayer({ src, className, size = 32, color, bgColor = 'transparent', ...props }) {
    const audioRef = useRef(null)
    const [isPlaying, setIsPlaying] = useState(false)
    const [duration, setDuration] = useState(0)
    const [currentTime, setCurrentTime] = useState(0)


    useEffect(() => {
        if (!audioRef.current) return

        const onPlay = () => setIsPlaying(true)
        const onPause = () => setIsPlaying(false)
        audioRef.current.addEventListener('play', onPlay)
        audioRef.current.addEventListener('pause', onPause)

        return () => {
            audioRef.current?.removeEventListener('play', onPlay)
            audioRef.current?.removeEventListener('pause', onPause)
        }
    }, [audioRef?.current])

    const updateCurrentTimeTimeout = useRef()
    useEffect(() => {
        const audioElement = audioRef.current
        if (!audioElement) return

        const handleTimeUpdate = () => {
            if (!isNaN(audioElement.duration) && audioElement.duration != Infinity) {
                // console.log(audioElement.duration)

                setDuration(audioElement.duration)
            }

            if (updateCurrentTimeTimeout.current) return
            updateCurrentTimeTimeout.current = setTimeout(() => {
                // console.log('>> setCurrentTime:' +audioElement.currentTime);
                setCurrentTime(audioElement.currentTime)
                updateCurrentTimeTimeout.current = null
            }, 500)
        }

        audioElement.addEventListener('timeupdate', handleTimeUpdate)

        return () => {
            audioElement.removeEventListener('timeupdate', handleTimeUpdate)
        }
    }, [isPlaying, audioRef.current])


    return <div className={className} {...props}>
        <div
            className={`cursor-pointer relative`}
            onClick={(e) => {
                e.stopPropagation()

                if (!audioRef?.current.src)
                    audioRef.current.src = src

                if (audioRef?.current?.paused)
                    audioRef?.current?.play()
                else
                    audioRef?.current?.pause()
            }}>
            {/*<RiFileMusicLine />*/}
            {!isPlaying && <HiPlay size={size || 32} color={color} />}
            {isPlaying && <HiPause size={size || 32} color={color} />}
            <Progress
                className="!absolute top-[0px] right-[0px]"
                showInfo={false}
                variant="circle"
                bgColor={bgColor}
                width={size}
                color={color}
                percent={currentTime / Math.max(1, duration) * 100}
            />
            <audio ref={audioRef} style={{ display: 'none' }} />
        </div>
    </div>
}
